/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

var props = {
  activable: Boolean,
  activeMultiple: Boolean,
  actived: {
    type: Array
  },
  defaultActived: {
    type: Array
  },
  allowFoldNodeOnFilter: Boolean,
  checkProps: {
    type: Object
  },
  checkStrictly: Boolean,
  checkable: Boolean,
  data: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  disableCheck: {
    type: [Boolean, Function],
    "default": false
  },
  disabled: Boolean,
  draggable: Boolean,
  empty: {
    type: [String, Function],
    "default": ""
  },
  expandAll: Boolean,
  expandLevel: {
    type: Number,
    "default": 0
  },
  expandMutex: Boolean,
  expandOnClickNode: Boolean,
  expandParent: Boolean,
  expanded: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  defaultExpanded: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  filter: {
    type: Function
  },
  height: {
    type: [String, Number]
  },
  hover: Boolean,
  icon: {
    type: [Boolean, Function],
    "default": true
  },
  keys: {
    type: Object
  },
  label: {
    type: [String, Boolean, Function],
    "default": true
  },
  lazy: {
    type: Boolean,
    "default": true
  },
  line: {
    type: [Boolean, Function],
    "default": false
  },
  load: {
    type: Function
  },
  maxHeight: {
    type: [String, Number]
  },
  operations: {
    type: Function
  },
  scroll: {
    type: Object
  },
  transition: {
    type: Boolean,
    "default": true
  },
  value: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  defaultValue: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  valueMode: {
    type: String,
    "default": "onlyLeaf",
    validator: function validator(val) {
      if (!val) return true;
      return ["onlyLeaf", "parentFirst", "all"].includes(val);
    }
  },
  onActive: Function,
  onChange: Function,
  onClick: Function,
  onDragEnd: Function,
  onDragLeave: Function,
  onDragOver: Function,
  onDragStart: Function,
  onDrop: Function,
  onExpand: Function,
  onLoad: Function,
  onScroll: Function
};

export { props as default };
//# sourceMappingURL=props.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/tree/props.js
// module id = null
// module chunks = 